import {RestApiService, IRestApiService} from '@techsee/techsee-client-infra/lib/services/RestApiService';
import {IUserUpdateParams} from '../app.contracts';
import {IAuthService} from './auth/auth.service';

export interface ITsAppUserService {
    update(userId: string, params: IUserUpdateParams): Promise<void>;
}

export class TsAppUserService implements ITsAppUserService {
    private _restApiService: IRestApiService;
    private _apiUrl: string;
    private _authService: IAuthService;

    constructor(apiUrl: string, authService: IAuthService) {
        this._apiUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
        this._authService = authService;
        const authToken = authService.getAuthToken() || '';
        this._restApiService = new RestApiService(this._apiUrl, authToken);
    }

    async update(userId: string, params: IUserUpdateParams): Promise<void> {
        const token = this._authService.getAuthToken();
        if (!token) {
            throw new Error('No auth token available');
        }
        const restApiService = new RestApiService(this._apiUrl, undefined, {Authorization: `Bearer ${token}`});
        await restApiService.put(`/api/users/${userId}`, params);
    }
}
